module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To the memory of the twenty-one men of the 1st Suffolk who died on active service during the Malayan Emergency. This work is dedicated in proud and affectionate remembrance of them:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentqt"
  }, [_vm._v("22221729 Sgt. J.A. Ashdown")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("5837855   Sgt. D. Westin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22305572 Cpl. S. Bailey")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("5883960   Cpl. H. Holland")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("21059924 L/Cpl. F.T.C. Mallows")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("14459864 L/Cpl. H.R. Simmonds")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("5775902   L/Cpl. S.E. Thompsett")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22614578 Pte. B.V. Ansell")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22259033 Pte. J.D. Edwards")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22322782 Pte. L.G. Killick")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22602535 Pte. B. Larman")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22329839 Pte. F.L. Lewis")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("21041416 Pte. R.A. Mills")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22403901 Pte. R. Moore")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22078754 Pte. D. Nobbs")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("14217245 Pte. L.R. Payne")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("5774520   Pte. W.G. Pearce")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22350436 Pte. E.A. Riches")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("5837859   Bdm. M.S. Swann")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22444978 Pte. H. Walker")]), _vm._v(" "), _c('p', {
    staticClass: "noindentq"
  }, [_vm._v("22395548 Pte. D. Wilson")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16bf3363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedication.vue
// module id = 66
// module chunks = 0